export enum DeeplinkKind {
  SocialShare = 'socialShare',
  Task = 'task',
  ProjectJson = 'projectJson',
  Preset = 'preset',
  Category = 'category',
  Tool = 'tool',
  None = 'none',
}

export type Deeplink =
  | { kind: DeeplinkKind.SocialShare; fileUrl: string }
  | { kind: DeeplinkKind.Task; taskId: string }
  | { kind: DeeplinkKind.ProjectJson; jsonUrl: string }
  | {
      kind: DeeplinkKind.Preset;
      presetId: string;
      category?: string;
      openChooser?: boolean;
    }
  | { kind: DeeplinkKind.Category; category: string }
  | { kind: DeeplinkKind.Tool; tool: string }
  | { kind: DeeplinkKind.None };
